import React from 'react';
import CheckoutWrapper from '../components/CheckoutWrapper';
import CheckoutItemContainer from '../components/CheckoutItemContainer';
import Media from '../components/Media';
import Product from '../components/Product';
import OrderBumps from '../components/CheckoutForm/components/OrderBumps';
import Variants from '../components/CheckoutForm/components/Variants';
import CheckoutForm from '../components/CheckoutForm';
import useCheckoutState from '../hooks/useCheckoutState';
import { getMedia } from '../lib/getMedia';

export default function CheckoutDoubleBanner() {
  const { checkoutType, checkout, seller, query } = useCheckoutState();
  const { product } = checkout;

  const media = getMedia({ checkout, product });

  return (
    <CheckoutWrapper className="cp_checkout" checkoutType={checkoutType}>
      <CheckoutItemContainer className="cp_card" checkoutType={checkoutType}>
        <Media media={media} />

        <div className="grid grid-cols-2">
          <div className="col-span-1 border-r border-gray-100 pt-2">
            <Product />

            {checkout.variantsPosition === 'left' && (
              <div className="cp_variants-wrapper mt-6">
                <Variants />
              </div>
            )}

            {/* This layout predates the content/form position setting and splits
                on left/right instead, so bumps simply follow the variants into
                whichever column holds them. */}
            {checkout.variantsPosition === 'left' && (
              <div className="cp_order-bumps-wrapper mt-6">
                <OrderBumps />
              </div>
            )}
          </div>

          <div className="col-span-1 pt-2">
            {checkout.variantsPosition === 'right' && (
              <div className="cp_variants-wrapper mt-4 border-b border-gray-100">
                <Variants />
              </div>
            )}

            {checkout.variantsPosition !== 'left' && (
              <div className="cp_order-bumps-wrapper mt-4">
                <OrderBumps />
              </div>
            )}

            <CheckoutForm />
          </div>
        </div>
      </CheckoutItemContainer>
    </CheckoutWrapper>
  );
}
